// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentBlockFaq_wrapper__Qx8Dd","title":"ContentBlockFaq_title__npFC9"};